import { GameStats } from '../../lib/localStorage'
import { Progress } from './Progress'
import { generateEmojiGrid } from '../../lib/share'
import { GAME_TITLE } from '../../constants/strings'

type Props = {
  gameStats: GameStats
}

export const Histogram = ({ gameStats }: Props) => {
  const winDistribution = gameStats.winDistribution
  const maxValue = Math.max(...winDistribution)

  return (
    <div className="columns-1 justify-left m-2 text-sm dark:text-white">
      {winDistribution.map((value, i) => (
        <Progress
          key={i}
          index={i}
          size={90 * (value / maxValue)}
          label={String(value)}
        />
      ))}
    </div>
  )
}

type PrintProps = {
  guesses: string[],
  lost: boolean,
  isHardMode: boolean
}



export const PrintStatus = ({ guesses, lost, isHardMode }: PrintProps) => {
  var result =generateEmojiGrid(guesses)

  return (
    <div id="result" className="columns-1 justify-left m-2 text-sm dark:text-white">
      <span>{GAME_TITLE} {lost ? 'X' : guesses.length}/8</span> <br />
      <pre style={{paddingTop: 10, lineHeight: 1.8}}>{result}</pre>
      <div style={{paddingTop: 20, paddingBottom: 15}}>
        ¡Compártelo en Instagram y etiquétanos a @cazadoresdeescapes!
      </div>
    </div>
  )
}

